import { useIntl } from '@/intl'
import TopNavigationBarItem from '@/scopes/common/components/Header/TopNavigationBarItem'
import { getLanguageSettings } from '@/scopes/common/domain/policies/site'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { isClient } from '@/utilities'
import { space, tok, tokPx, zIndex } from '@sunwebgroup/ui-components'
import { Icon, Menu } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const ArrowIcon = styled(Icon)`
  right: 2px;
  top: 9px;
  position: absolute;
`

const LanguageSwitchTrigger = styled(TopNavigationBarItem)`
  position: relative;
  // Padding is set to important due to errors in styled-components. To be removed when fix is found
  padding: ${space('primitives_space_8')} ${space('primitives_space_24')} ${space('primitives_space_8')}  ${space('primitives_space_8')} !important;
  margin-right: ${space('primitives_space_4')};
  border-radius: ${tokPx('primitives_corner_radius_full')};

  &[data-state='open'] {
    background: ${tok('primitives_color_neutral_150')};

    ${ArrowIcon} {
      transform: rotate(180deg);
    }
  }
`

const LanguageMenuContent = styled(Menu.Content)`
  z-index: ${zIndex.header};
`

export function LanguageSwitch() {
  const siteName = useConfiguration('siteName')
  const intl = useIntl()
  const langSettings = getLanguageSettings(siteName)

  if (!langSettings)
    return null

  const matchesLanguageWithUrl = (urlMatcher: string) => {
    if (!isClient())
      return false

    const url = window.location.href
    return url.includes(urlMatcher)
  }

  return (
    <Menu.Root>
      <Menu.Trigger>
        <LanguageSwitchTrigger>
          <Icon glyph="World" />
          <ArrowIcon glyph="ChevronDownExtraSmall" />
        </LanguageSwitchTrigger>
      </Menu.Trigger>
      <LanguageMenuContent position="bottom-left">
        {langSettings.map(setting => (
          <Menu.LinkItem
            href={setting.url}
            key={setting.url}
            glyph={
              matchesLanguageWithUrl(setting.urlMatcher)
                ? 'CheckMarkSmall'
                : undefined
            }
          >
            {intl.formatMessage({ id: `${setting.translationKey}` })}
          </Menu.LinkItem>
        ))}
      </LanguageMenuContent>
    </Menu.Root>
  )
}
